import { aq as getDefaultExportFromCjs, u as useStrings, b as useTypedDispatch, c as classNames, U as __awaiter, a2 as queueNotification } from './responsive-b521ac2b.js';
import { r as requireAssertString } from './SkeletonContainer-3c6bc430.js';
import React__default, { useId, Fragment } from 'react';
import { I as IconButton } from './mediaQueries-6282b8d3.js';

var isEmailExports$1 = {};
var isEmail$1 = {
  get exports(){ return isEmailExports$1; },
  set exports(v){ isEmailExports$1 = v; },
};

var mergeExports = {};
var merge = {
  get exports(){ return mergeExports; },
  set exports(v){ mergeExports = v; },
};

var hasRequiredMerge;

function requireMerge () {
	if (hasRequiredMerge) return mergeExports;
	hasRequiredMerge = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = merge;

		function merge() {
		  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		  var defaults = arguments.length > 1 ? arguments[1] : undefined;

		  for (var key in defaults) {
		    if (typeof obj[key] === 'undefined') {
		      obj[key] = defaults[key];
		    }
		  }

		  return obj;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
} (merge, mergeExports));
	return mergeExports;
}

var isByteLengthExports = {};
var isByteLength = {
  get exports(){ return isByteLengthExports; },
  set exports(v){ isByteLengthExports = v; },
};

var hasRequiredIsByteLength;

function requireIsByteLength () {
	if (hasRequiredIsByteLength) return isByteLengthExports;
	hasRequiredIsByteLength = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isByteLength;

		var _assertString = _interopRequireDefault(requireAssertString());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		/* eslint-disable prefer-rest-params */
		function isByteLength(str, options) {
		  (0, _assertString.default)(str);
		  var min;
		  var max;

		  if (_typeof(options) === 'object') {
		    min = options.min || 0;
		    max = options.max;
		  } else {
		    // backwards compatibility: isByteLength(str, min [, max])
		    min = arguments[1];
		    max = arguments[2];
		  }

		  var len = encodeURI(str).split(/%..|./).length - 1;
		  return len >= min && (typeof max === 'undefined' || len <= max);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
} (isByteLength, isByteLengthExports));
	return isByteLengthExports;
}

var isFQDNExports = {};
var isFQDN = {
  get exports(){ return isFQDNExports; },
  set exports(v){ isFQDNExports = v; },
};

var hasRequiredIsFQDN;

function requireIsFQDN () {
	if (hasRequiredIsFQDN) return isFQDNExports;
	hasRequiredIsFQDN = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isFQDN;

		var _assertString = _interopRequireDefault(requireAssertString());

		var _merge = _interopRequireDefault(requireMerge());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var default_fqdn_options = {
		  require_tld: true,
		  allow_underscores: false,
		  allow_trailing_dot: false,
		  allow_numeric_tld: false,
		  allow_wildcard: false
		};

		function isFQDN(str, options) {
		  (0, _assertString.default)(str);
		  options = (0, _merge.default)(options, default_fqdn_options);
		  /* Remove the optional trailing dot before checking validity */

		  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
		    str = str.substring(0, str.length - 1);
		  }
		  /* Remove the optional wildcard before checking validity */


		  if (options.allow_wildcard === true && str.indexOf('*.') === 0) {
		    str = str.substring(2);
		  }

		  var parts = str.split('.');
		  var tld = parts[parts.length - 1];

		  if (options.require_tld) {
		    // disallow fqdns without tld
		    if (parts.length < 2) {
		      return false;
		    }

		    if (!/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
		      return false;
		    } // disallow spaces


		    if (/\s/.test(tld)) {
		      return false;
		    }
		  } // reject numeric TLDs


		  if (!options.allow_numeric_tld && /^\d+$/.test(tld)) {
		    return false;
		  }

		  return parts.every(function (part) {
		    if (part.length > 63) {
		      return false;
		    }

		    if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) {
		      return false;
		    } // disallow full-width chars


		    if (/[\uff01-\uff5e]/.test(part)) {
		      return false;
		    } // disallow parts starting or ending with hyphen


		    if (/^-|-$/.test(part)) {
		      return false;
		    }

		    if (!options.allow_underscores && /_/.test(part)) {
		      return false;
		    }

		    return true;
		  });
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
} (isFQDN, isFQDNExports));
	return isFQDNExports;
}

var isIPExports = {};
var isIP = {
  get exports(){ return isIPExports; },
  set exports(v){ isIPExports = v; },
};

var hasRequiredIsIP;

function requireIsIP () {
	if (hasRequiredIsIP) return isIPExports;
	hasRequiredIsIP = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isIP;

		var _assertString = _interopRequireDefault(requireAssertString());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/**
		11.3.  Examples

		   The following addresses

		             fe80::1234 (on the 1st link of the node)
		             ff02::5678 (on the 5th link of the node)
		             ff08::9abc (on the 10th organization of the node)

		   would be represented as follows:

		             fe80::1234%1
		             ff02::5678%5
		             ff08::9abc%10

		   (Here we assume a natural translation from a zone index to the
		   <zone_id> part, where the Nth zone of any scope is translated into
		   "N".)

		   If we use interface names as <zone_id>, those addresses could also be
		   represented as follows:

		            fe80::1234%ne0
		            ff02::5678%pvc1.3
		            ff08::9abc%interface10

		   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
		   to the 5th link, and "interface10" belongs to the 10th organization.
		 * * */
		var IPv4SegmentFormat = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
		var IPv4AddressFormat = "(".concat(IPv4SegmentFormat, "[.]){3}").concat(IPv4SegmentFormat);
		var IPv4AddressRegExp = new RegExp("^".concat(IPv4AddressFormat, "$"));
		var IPv6SegmentFormat = '(?:[0-9a-fA-F]{1,4})';
		var IPv6AddressRegExp = new RegExp('^(' + "(?:".concat(IPv6SegmentFormat, ":){7}(?:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){6}(?:").concat(IPv4AddressFormat, "|:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){5}(?::").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){4}(?:(:").concat(IPv6SegmentFormat, "){0,1}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){3}(?:(:").concat(IPv6SegmentFormat, "){0,2}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){2}(?:(:").concat(IPv6SegmentFormat, "){0,3}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){1}(?:(:").concat(IPv6SegmentFormat, "){0,4}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat(IPv6SegmentFormat, "){0,5}:").concat(IPv4AddressFormat, "|(?::").concat(IPv6SegmentFormat, "){1,7}|:))") + ')(%[0-9a-zA-Z-.:]{1,})?$');

		function isIP(str) {
		  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
		  (0, _assertString.default)(str);
		  version = String(version);

		  if (!version) {
		    return isIP(str, 4) || isIP(str, 6);
		  }

		  if (version === '4') {
		    if (!IPv4AddressRegExp.test(str)) {
		      return false;
		    }

		    var parts = str.split('.').sort(function (a, b) {
		      return a - b;
		    });
		    return parts[3] <= 255;
		  }

		  if (version === '6') {
		    return !!IPv6AddressRegExp.test(str);
		  }

		  return false;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
} (isIP, isIPExports));
	return isIPExports;
}

var hasRequiredIsEmail;

function requireIsEmail () {
	if (hasRequiredIsEmail) return isEmailExports$1;
	hasRequiredIsEmail = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isEmail;

		var _assertString = _interopRequireDefault(requireAssertString());

		var _merge = _interopRequireDefault(requireMerge());

		var _isByteLength = _interopRequireDefault(requireIsByteLength());

		var _isFQDN = _interopRequireDefault(requireIsFQDN());

		var _isIP = _interopRequireDefault(requireIsIP());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var default_email_options = {
		  allow_display_name: false,
		  require_display_name: false,
		  allow_utf8_local_part: true,
		  require_tld: true,
		  blacklisted_chars: '',
		  ignore_max_length: false,
		  host_blacklist: []
		};
		/* eslint-disable max-len */

		/* eslint-disable no-control-regex */

		var splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
		var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
		var gmailUserPart = /^[a-z\d]+$/;
		var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
		var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
		var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
		var defaultMaxEmailLength = 254;
		/* eslint-enable max-len */

		/* eslint-enable no-control-regex */

		/**
		 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
		 * @param {String} display_name
		 */

		function validateDisplayName(display_name) {
		  var display_name_without_quotes = display_name.replace(/^"(.+)"$/, '$1'); // display name with only spaces is not valid

		  if (!display_name_without_quotes.trim()) {
		    return false;
		  } // check whether display name contains illegal character


		  var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);

		  if (contains_illegal) {
		    // if contains illegal characters,
		    // must to be enclosed in double-quotes, otherwise it's not a valid display name
		    if (display_name_without_quotes === display_name) {
		      return false;
		    } // the quotes in display name must start with character symbol \


		    var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;

		    if (!all_start_with_back_slash) {
		      return false;
		    }
		  }

		  return true;
		}

		function isEmail(str, options) {
		  (0, _assertString.default)(str);
		  options = (0, _merge.default)(options, default_email_options);

		  if (options.require_display_name || options.allow_display_name) {
		    var display_email = str.match(splitNameAddress);

		    if (display_email) {
		      var display_name = display_email[1]; // Remove display name and angle brackets to get email address
		      // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)

		      str = str.replace(display_name, '').replace(/(^<|>$)/g, ''); // sometimes need to trim the last space to get the display name
		      // because there may be a space between display name and email address
		      // eg. myname <address@gmail.com>
		      // the display name is `myname` instead of `myname `, so need to trim the last space

		      if (display_name.endsWith(' ')) {
		        display_name = display_name.substr(0, display_name.length - 1);
		      }

		      if (!validateDisplayName(display_name)) {
		        return false;
		      }
		    } else if (options.require_display_name) {
		      return false;
		    }
		  }

		  if (!options.ignore_max_length && str.length > defaultMaxEmailLength) {
		    return false;
		  }

		  var parts = str.split('@');
		  var domain = parts.pop();
		  var lower_domain = domain.toLowerCase();

		  if (options.host_blacklist.includes(lower_domain)) {
		    return false;
		  }

		  var user = parts.join('@');

		  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
		    /*
		      Previously we removed dots for gmail addresses before validating.
		      This was removed because it allows `multiple..dots@gmail.com`
		      to be reported as valid, but it is not.
		      Gmail only normalizes single dots, removing them from here is pointless,
		      should be done in normalizeEmail
		    */
		    user = user.toLowerCase(); // Removing sub-address from username before gmail validation

		    var username = user.split('+')[0]; // Dots are not included in gmail length restriction

		    if (!(0, _isByteLength.default)(username.replace(/\./g, ''), {
		      min: 6,
		      max: 30
		    })) {
		      return false;
		    }

		    var _user_parts = username.split('.');

		    for (var i = 0; i < _user_parts.length; i++) {
		      if (!gmailUserPart.test(_user_parts[i])) {
		        return false;
		      }
		    }
		  }

		  if (options.ignore_max_length === false && (!(0, _isByteLength.default)(user, {
		    max: 64
		  }) || !(0, _isByteLength.default)(domain, {
		    max: 254
		  }))) {
		    return false;
		  }

		  if (!(0, _isFQDN.default)(domain, {
		    require_tld: options.require_tld
		  })) {
		    if (!options.allow_ip_domain) {
		      return false;
		    }

		    if (!(0, _isIP.default)(domain)) {
		      if (!domain.startsWith('[') || !domain.endsWith(']')) {
		        return false;
		      }

		      var noBracketdomain = domain.substr(1, domain.length - 2);

		      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
		        return false;
		      }
		    }
		  }

		  if (user[0] === '"') {
		    user = user.slice(1, user.length - 1);
		    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
		  }

		  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
		  var user_parts = user.split('.');

		  for (var _i = 0; _i < user_parts.length; _i++) {
		    if (!pattern.test(user_parts[_i])) {
		      return false;
		    }
		  }

		  if (options.blacklisted_chars) {
		    if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), 'g')) !== -1) return false;
		  }

		  return true;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
} (isEmail$1, isEmailExports$1));
	return isEmailExports$1;
}

var isEmailExports = requireIsEmail();
var isValidEmail = /*@__PURE__*/getDefaultExportFromCjs(isEmailExports);

function isNot(validator) {
    return value => !validator(value);
}
function isNotEmpty(trim = true) {
    return value => {
        if (trim) {
            value = value.trim();
        }
        return value !== '';
    };
}
function isSame(value) {
    return valueToValidate => {
        if (value instanceof Function) {
            return valueToValidate === value();
        }
        else {
            return valueToValidate === value;
        }
    };
}
function isLength(min, max) {
    return value => {
        return value.length >= min && (max === undefined || value.length <= max);
    };
}
function isNonRequiredLength(min, max) {
    return value => {
        return (value === undefined || value === null || value === '') || value.length >= min && (max === undefined || value.length <= max);
    };
}
function isEmail() {
    return value => isValidEmail(value);
}
function isFileSizeAcceptable(size) {
    return value => {
        if (!value) {
            return true;
        }
        return value.size <= size;
    };
}
function isTruthy() {
    return (value) => Boolean(value);
}
function isNumberOrNumberWithSpaces() {
    return value => new RegExp('^[0-9\\s]+$').test(value);
}

var faCopy = {};

var hasRequiredFaCopy;

function requireFaCopy () {
	if (hasRequiredFaCopy) return faCopy;
	hasRequiredFaCopy = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'copy';
		var width = 448;
		var height = 512;
		var ligatures = [];
		var unicode = 'f0c5';
		var svgPathData = 'M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faCopy = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faCopy));
	return faCopy;
}

var faCopyExports = requireFaCopy();

const DefinitionList = props => {
    const listId = useId();
    const { definitionList: definitionListStrings } = useStrings();
    const dispatch = useTypedDispatch();
    function renderDefinition(definition, index) {
        const id = `DefinitionList-${listId}-${index}`;
        const { value, name, dtClassName, ddClassName, copyToClipboard } = definition;
        if (!value && props.skipMissingValues) {
            return null;
        }
        const copyValueToClipboard = (key, value) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield navigator.clipboard.writeText(value);
                dispatch(queueNotification(definitionListStrings.copySuccess(key)));
            }
            catch (error) {
                dispatch(queueNotification(definitionListStrings.copyError));
            }
        });
        const copyBtnVisible = copyToClipboard && typeof name === 'string' && typeof value === 'string';
        return (React__default.createElement(Fragment, { key: id },
            React__default.createElement("dt", { id: id, className: classNames(dtClassName, { 'DefinitionList-btnVisible': copyBtnVisible }) }, name),
            React__default.createElement("div", { className: "DefinitionList-valueColumn" },
                React__default.createElement("dd", { "aria-labelledby": id, className: classNames(ddClassName, { 'DefinitionList-btnVisible': copyBtnVisible }) }, value !== null && value !== void 0 ? value : React__default.createElement("span", null, "\u2014")),
                copyBtnVisible && (React__default.createElement(IconButton, { icon: faCopyExports.faCopy, onClick: () => copyValueToClipboard(name, value), title: definitionListStrings.copyTitle(name) })))));
    }
    // https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/pull/807
    // eslint-disable-next-line jsx-a11y/no-redundant-roles
    return React__default.createElement("dl", { className: "DefinitionList", role: "list", "aria-label": props.label }, props.definitions.map(renderDefinition));
};

export { DefinitionList as D, isLength as a, isNonRequiredLength as b, isNot as c, isSame as d, isEmail as e, isNumberOrNumberWithSpaces as f, isTruthy as g, isFileSizeAcceptable as h, isNotEmpty as i, requireMerge as r };
